// extracted by mini-css-extract-plugin
export default {"settings-column-title-button":"styles_settings-column-title-button__ZHuuC"};